module.exports = __webpack_public_path__ + "img/BIM.1b62273b.jpg";